import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@mulesoft/anypoint-components/lib/Button';
import { getPath } from '~/utils/routes';
import styles from './Header.css';

const Header = ({ emptyState }) => {
  const addScannerPath = getPath('agentScannersAdd');

  return (
    <div
      className={styles.headerBar}
      data-test-id="scan-configurations-section-header"
    >
      <div>
        <h2>Agent Scanners</h2>
      </div>
      <div
        className={styles.headerBarActions}
        data-test-id="scan-configurations-section-buttons"
      >
        <Link to={addScannerPath} display-if={!emptyState}>
          <Button
            type="button"
            kind="primary"
            data-test-id="add-scanner-button"
          >
            Add Scanner
          </Button>
        </Link>
      </div>
    </div>
  );
};

Header.propTypes = {
  emptyState: PropTypes.bool
};

export default Header;
